import axios from 'axios'
import { ElMessageBox } from 'element-plus'
import router from '@/router'

const publicUrl = 'https://apiv2.beasymoz.com/'
// const publicUrl = 'http://192.168.43.147:8000/'
// const publicUrl = 'http://192.168.18.10:8000/'
// const publicUrl = 'http://127.0.0.1:8000/'
const baseUrl = publicUrl + 'api/'

const getAuthHeader = () => {
    const token = sessionStorage.getItem("token")
    return token ? { Authorization: `Bearer ${token}`,  'X-Authorization': `Bearer ${token}` } : {}
}

const instance = axios.create({
    baseURL: baseUrl
})

instance.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            ElMessageBox.alert('Sua sessão expirou. Por favor, faça login.', 'Sessão Expirada', {
                confirmButtonText: 'OK',
                type: 'warning',
                callback: () => { router.push({ name: 'Login' }) }
            })
        }
        if (error.response && error.response.status === 403) {
            ElMessageBox.alert('Não tem permissão para entrar nessa área', 'Acesso restrito', {
                confirmButtonText: 'OK',
                type: 'warning',
                callback: () => { router.push({ name: 'Login' }) }
            })
        }
        return Promise.reject(error)
    }
)

const Api = {
    publicUrl,
    async post(url: string, data: Record<string, any>, form: FormData | null = null) {
        const formData = new FormData()
        if (!form) {
            Object.keys(data).forEach(key => {
                formData.append(key, data[key])
            })
        }

        try {
            const response = await instance.post(url, form ? form : formData, {
                headers: {
                    ...getAuthHeader(),
                    'Content-Type': 'multipart/form-data'
                }
            })
            return response
        } catch (error: any) {
            return error.response
        }
    },

    async get(url: string, params?: Record<string, any>) {
        try {
            const response = await instance.get(url, {
                headers: getAuthHeader(),
                params
            })
            return response
        } catch (error: any) {
            return error.response
        }
    },

    async put(url: string, data: Record<string, any>, form: FormData | null = null) {
        try {
            const response = await instance.put(url, form ? form:data, {
                headers: {
                    ...getAuthHeader(),
                    'Content-Type': 'application/json'
                }
            })
            return response
        } catch (error: any) {
            return error.response
        }
    },

    async delete(url: string) {
        try {
            const response = await instance.delete(url, {
                headers: getAuthHeader()
            })
            return response
        } catch (error: any) {
            return error.response
        }
    }
}

export default Api
